import { render, staticRenderFns } from "./WarrantyPolicy.vue?vue&type=template&id=3e94d5bf&scoped=true&"
var script = {}
import style0 from "./WarrantyPolicy.vue?vue&type=style&index=0&id=3e94d5bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94d5bf",
  null
  
)

export default component.exports